// Components/common/EmployeeSwitch.js
// ─────────────────────────────────────────────────────────────────────────
// Route-level switch: managers (Super Admin / Branch Admin / Admin) always get
// the existing page untouched. Other roles get the personal "My …" screen.
// `?view=full` opens the existing page for anyone, so every existing tool
// stays reachable from the personal screen ("All tools" button).
// ─────────────────────────────────────────────────────────────────────────
import React from "react";
import { useSearchParams } from "react-router-dom";
import { useEmployeeView } from "../../utils/employeeView";
import TableLoader from "./TableLoader";

const EmployeeSwitch = ({ admin, employee }) => {
  const { isEmployeeView, loading } = useEmployeeView();
  const [params] = useSearchParams();
  if (loading) return <TableLoader name="Page" />;
  if (!isEmployeeView || params.get("view") === "full") return admin;
  return employee;
};

export default EmployeeSwitch;
